module.exports = __webpack_public_path__ + "img/social-networks.c05bd8d0.png";